import { ChevronRight, Delete, X } from "lucide-react";
import React from "react";
import "./PinKeypad.css";

export function PinKeypad({
    headerText,
    isClosable,
    onClose,
    showBackButton,
    onBack,
    pinValue,
    onPinChange
}: {
    headerText: string;
    isClosable?: boolean;
    onClose?: () => void;
    showBackButton?: boolean;
    onBack?: () => void;
    pinValue: string;
    onPinChange: (val: string) => void;
}) {
    const onPinPress = (val: string) => {
        if (val === 'DEL') {
            onPinChange(pinValue.slice(0, -1));
        } else {
            if (pinValue.length < 6) onPinChange(pinValue + val);
        }
    };
    return (
        <div className="pin-keypad-container">
            <div className="pin-keypad-header-wrapper">
                <p className="pin-keypad-header-text">{headerText}</p>
                {isClosable && onClose && (
                    <button onClick={onClose} className="pin-keypad-close-btn">
                        <X className="pin-keypad-close-icon" />
                    </button>
                )}
            </div>

            <div className="pin-keypad-dots-container">
                {[...Array(6)].map((_, i) => (
                    <div
                        key={i}
                        className={`pin-keypad-dot ${pinValue.length > i ? 'pin-keypad-dot-active' : 'pin-keypad-dot-inactive'}`}
                    />
                ))}
            </div>
            <div className="pin-keypad-grid">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 'CLR', 0, 'DEL'].map((num) => (
                    <button
                        key={num.toString()}
                        onClick={() => {
                            if (num === 'CLR') onPinChange('');
                            else if (num === 'DEL') onPinPress('DEL');
                            else onPinPress(num.toString());
                        }}
                        className="pin-keypad-btn"
                    >
                        {num === 'DEL' ? <Delete className="pin-keypad-del-icon" /> : num}
                    </button>
                ))}
            </div>
            {showBackButton && onBack && (
                <button
                    onClick={onBack}
                    className="pin-keypad-back-btn"
                >
                    <ChevronRight className="pin-keypad-back-icon" />
                    Volver al menú
                </button>
            )}
        </div>
    );
}